export default {
  // serverURI: 'http://192.168.0.28:8000/api',
  // serverURI: 'http://localhost:8484/api',
  // serverURI: 'http://localhost:8090/api',
  // serverURI: 'http://172.16.20.112:8090/api',
  // serverURI: 'http://172.16.20.112:8484/api',
  serverURI: "https://merchantportal.co-opbank.co.ke/api",
  fixedLayout: false,
  hideLogoOnMobile: false,
  sessionTimeout: 10,
  multifactorAuthOn: false,
  // http://192.168.0.28:8000/api
  // https://merchantportal.co-opbank.co.ke/api
  // http://127.0.0.1:8092/api
};



// WEBPACK FOOTER //
// ./src/config/index.js